"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationBuilderClientRectUtils = void 0;
var LocationBuilderClientRectUtils = (function () {
    function LocationBuilderClientRectUtils() {
    }
    LocationBuilderClientRectUtils.prototype.getFullBoundingClientRect = function (element) {
        var bounding = element.getBoundingClientRect();
        return {
            x: bounding.x + window.scrollX,
            y: bounding.y + window.scrollY,
            bottom: bounding.bottom + window.scrollY,
            right: bounding.right + window.scrollX,
            width: bounding.width,
            height: bounding.height,
        };
    };
    return LocationBuilderClientRectUtils;
}());
exports.LocationBuilderClientRectUtils = LocationBuilderClientRectUtils;
